<!-- 带筛选的表格 -->
<template>
  <div class="tableMain">
    <el-table
      ref="multipleTable"
      :data="tableData1"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      size="small"
      header-cell-class-name="headerClass"
      show-overflow-tooltip
      :header-cell-style="tableHeaderColor"
      @expand-change="openData"
      @selection-change="handleSelectionChange"
    >
      <!--  @selection-change="handleSelectionChange" -->
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column v-if="selectFlag" type="selection" width="55">
      </el-table-column>
      <el-table-column v-if="!selectFlag" label="序号" type="index" align="center">
      </el-table-column>
      <template v-for="(item, key) in tableColumn">
        <el-table-column
          v-if="item.isShow"
          :key="key"
          :prop="item.tabItem"
          :label="item.tabTh"
          align="center"
          :width="width"
          :column-key="item.tabItem"
          :filters="item.sortNum"
          :filter-method="filterHandler"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          v-else
          :key="key"
          :prop="item.tabItem"
          :label="item.tabTh"
          align="center"
          :width="width"
          show-overflow-tooltip
        ></el-table-column>
      </template>
      <!-- 标签插槽 -->
      <slot name="table_tag" />
      <!-- 下拉插槽 -->
      <slot name="table_select" />
      <!-- 展开插槽 -->
      <slot name="table_open" />
      <slot name="table_input" />
      <!-- 操作项插槽 -->
      <slot name="table_oper" />
      <!-- 操作项插槽 -->
    </el-table>
  </div>
</template>

<script>
import { log } from "util";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import { sortByKey } from "../../tests/unit/public";
export default {
  name: "tableMain",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      currentRows: "",
      menuVisible: false,
      tableColumn: null,
      multipleSelection:[]
    };
  },
  props: ["tableData1", "tableHeader", "width", "selectFlag"],
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    // 监听父组件传过来的表头变化
    tableHeader: function (data) {
      //监听属性变化
      this.tableColumn = data;
    },
  },
  //方法集合
  methods: {
    handleSelectionChange(val){
      this.multipleSelection = val;
      console.log(val);
      this.$store.commit("getSelectData", this.multipleSelection);
    },
    getSelectionChange(){
      return this.selectionChangeData
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      // console.log(property);
      return row[property] === value;
    },
    // 修改表头样式
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #EDEDED;color: #333333;font-weight: 500;";
      }
    },
    // 表格展开事件
    openData(row, expandedRows) {
      if (expandedRows.length != 0) {
        this.$emit("getOpenData", row);
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.tableColumn = this.tableHeader;
    let arr = [];
    this.$store.commit("getSelectData", arr);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
/* @import url(); 引入公共css类 */
/*表格*/
.tableMain .el-table th.gutter {
  display: table-cell !important;
}
.headerClass {
  background: #ededed !important;
  font-weight: 800 !important;
  color: rgba(51, 51, 51, 1) !important;
}
.tableMain .el-table thead {
  color: #000000 !important;
}
.tableMain .el-table td,
.tableMain .el-table th {
  padding: 8px 0 !important;
}
/*排序按钮*/
.table-sort {
  margin-bottom: 0px;
  width: 100%;
  text-align: right;
}

.table-sort .el-button {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-right: 0;
  width: 150px;
  height: 32px;
  line-height: 32px;
}
.menu-type {
  display: inline-block;
  width: 90%;
  text-align: left;
}
.menu-sort {
  position: absolute;
  z-index: 111;
  top: 32px;
  right: 0;
  padding: 10px 5px 10px 10px;
  width: 150px;
  max-height: 400px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}
.menu-sort .el-checkbox__label {
  line-height: 25px !important;
  font-size: 14px !important;
}
</style>
